import {
  KiqOnboardingStep,
  KiqQuestionsStep,
  LandingStep,
  PersonalInfoStep,
  ReviewPersonalInfoStep,
  TermsStep,
} from '../components/Steps';
import {
  ErrorForbiddenIpStep,
  ErrorFrozenAccountStep,
  ErrorFrozenAccountWarningStep,
  ErrorGenericStep,
  ErrorIncorrectAnswersStep,
  ErrorUserLockedOutStep,
  ErrorUserNotFoundLockedOutStep,
  ErrorUserNotFoundStep,
} from '../components/Steps/ErrorSteps';
import PrivacyCard from '../components/PrivacyCard';
import type { ErrorWizardStep, WizardStep } from './wizardTypes';
import { ErrorWizardStepId, ErrorWizardStepTitle, WizardStepId, WizardStepTitle } from './wizardTypes';

export const STEPS: Array<WizardStep> = [
  {
    id: WizardStepId.Landing,
    title: WizardStepTitle.Landing,
    Component: LandingStep,
    nextButtonText: 'Continue',
    renderBackButton: false,
  },
  {
    id: WizardStepId.Terms,
    title: WizardStepTitle.Terms,
    Component: TermsStep,
  },
  {
    id: WizardStepId.PersonalInfo,
    title: WizardStepTitle.PersonalInfo,
    Component: PersonalInfoStep,
    Tip: PrivacyCard,
  },
  {
    id: WizardStepId.ReviewPersonalInfo,
    title: WizardStepTitle.ReviewPersonalInfo,
    Component: ReviewPersonalInfoStep,
    nextButtonText: 'Verify identity',
  },
  {
    id: WizardStepId.KiqOnboarding,
    title: WizardStepTitle.KiqOnboarding,
    Component: KiqOnboardingStep,
    renderBackButton: false,
  },
  {
    id: WizardStepId.KiqQuestions,
    title: WizardStepTitle.KiqQuestions,
    Component: KiqQuestionsStep,
    Tip: PrivacyCard,
    renderBackButton: false,
  },
];

export const ERROR_STEPS: Record<ErrorWizardStepId, ErrorWizardStep> = {
  [ErrorWizardStepId.Generic]: {
    id: ErrorWizardStepId.Generic,
    title: ErrorWizardStepTitle.Generic,
    Component: ErrorGenericStep,
    nextButtonText: 'Done',
  },
  [ErrorWizardStepId.UserNotFound]: {
    id: ErrorWizardStepId.UserNotFound,
    title: ErrorWizardStepTitle.UserNotFound,
    Component: ErrorUserNotFoundStep,
    nextButtonText: 'Retry',
  },
  [ErrorWizardStepId.UserNotFoundLockedOut]: {
    id: ErrorWizardStepId.UserNotFoundLockedOut,
    title: ErrorWizardStepTitle.UserNotFoundLockedOut,
    Component: ErrorUserNotFoundLockedOutStep,
    nextButtonText: 'Done',
  },
  [ErrorWizardStepId.UserLockedOut]: {
    id: ErrorWizardStepId.UserLockedOut,
    title: ErrorWizardStepTitle.UserLockedOut,
    Component: ErrorUserLockedOutStep,
    nextButtonText: 'Done',
  },
  [ErrorWizardStepId.IncorrectAnswers]: {
    id: ErrorWizardStepId.IncorrectAnswers,
    title: ErrorWizardStepTitle.IncorrectAnswers,
    Component: ErrorIncorrectAnswersStep,
    nextButtonText: 'Retry',
  },
  [ErrorWizardStepId.FrozenAccount]: {
    id: ErrorWizardStepId.FrozenAccount,
    title: ErrorWizardStepTitle.FrozenAccount,
    Component: ErrorFrozenAccountStep,
    nextButtonText: 'Done',
  },
  [ErrorWizardStepId.FrozenAccountWarning]: {
    id: ErrorWizardStepId.FrozenAccountWarning,
    title: ErrorWizardStepTitle.FrozenAccountWarning,
    Component: ErrorFrozenAccountWarningStep,
    nextButtonText: 'Yes',
  },
  [ErrorWizardStepId.ForbiddenIp]: {
    id: ErrorWizardStepId.ForbiddenIp,
    title: ErrorWizardStepTitle.ForbiddenIp,
    Component: ErrorForbiddenIpStep,
    nextButtonText: 'Done',
  },
};
